import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './api-slice'
import { authSlice } from './auth-slice'
import ticketReducer from './ticket-slice'
import transportReducer from './transport-slice'
import cabanaReducer from './cabana-slice'
import cartReducer from './cart-slice'
import generalReducer from './general-slice'
import upsellReducer from './upsell-slice'
import orderReducer from './order-slice'
import accommodationReducer from './accommodation-slice'
import selfcareReducer from './selfcare-slice'
import selfcareCartReducer from './selfcare-cart-slice'
import unlimitedReducer from './unlimited-slice'
import vouchersReducer from './vouchers-slice'
import { ENV_LIVE } from 'constants/system'

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        [authSlice.reducerPath]: authSlice.reducer,
        general: generalReducer,
        cart: cartReducer,
        ticket: ticketReducer,
        transport: transportReducer,
        cabana: cabanaReducer,
        upsell: upsellReducer,
        order: orderReducer,
        accommodation: accommodationReducer,
        selfcare: selfcareReducer,
        selfcareCart: selfcareCartReducer,
        unlimited: unlimitedReducer,
        vouchers: vouchersReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            apiSlice.middleware,
            authSlice.middleware
        ),
    devTools: process.env.REACT_APP_ENV !== ENV_LIVE,
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
